import PropTypes from 'prop-types';
import React from 'react';

export class ListItem extends React.Component {
  onClick = () => {
    if (this.props.handleClick) {
      this.props.handleClick(this.props.index);
    }
  }

  onFocus = () => {
    if (this.props.handleOnFocus) {
      this.props.handleOnFocus();
    }
  }


  renderBadge() {
    if (this.props.displayBadge) {
      return (
        <span className="fa fa-circle theme"></span>
      );
    }
    return null;
  }

  renderItem(item, className) {
    if (!item) {
      return null;
    }

    if (typeof item === 'function') {
      return item();
    }

    return <span className={className}>{item}</span>;
  }

  render() {
    const { heading, subText, tertiaryText, className } = this.props;
    const itemClass = 'list-group-item';
    const buttonClass =  className || '';

    return (
      <li className={ itemClass } key={ this.props.index } >
          <a
            role="button"
            className={buttonClass}
            onClick={this.onClick}
            onFocus={this.onFocus}
          >
            { this.renderBadge() }
            { this.props.showItemArrow &&
              <span className="fa-solid fa-chevron-right chevron d-lg-none"></span> }
            { this.renderItem(heading, 'primary-text bold') }
            { this.renderItem(subText, 'secondary-text') }
            { this.renderItem(tertiaryText, 'tertiary-text') }
          </a>
      </li>);
  }
}

ListItem.propTypes = {
  heading: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  subText: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
  ]),
  tertiaryText: PropTypes.any,
  displayBadge: PropTypes.bool,
  className: PropTypes.string,
  index: PropTypes.number,
  handleClick: PropTypes.func,
  showItemArrow: PropTypes.bool,
  handleOnFocus: PropTypes.func,
};

ListItem.defaultProps = {
  showItemArrow: true,
};
